import { BoxProps, HStack, Icon, IconButton } from "@chakra-ui/react";
import HoneySlider from "components/HoneySlider";
import { HoneyPurchaseContainerValues } from "containers/HoneyPurchaseContainer";
import { BigNumber } from "ethers";
import { FaLock, FaLockOpen } from "react-icons/fa";

type PurchaseSliderProps = Omit<BoxProps, "onChange"> & {
  valueKey: string;
  label: string;
  values: HoneyPurchaseContainerValues;
  max: BigNumber;
  onChange: (valueKey: string, amount: BigNumber) => void;
  onLockToggle: (valueKey: string, isLocked: boolean) => void;
};

const HoneyPurchaseContainerSlider = ({
  valueKey,
  values,
  max,
  label,
  onChange,
  onLockToggle,
  ...rest
}: PurchaseSliderProps) => (
  <HStack
    w="full"
    spacing="4"
    px="4"
    py="1.5"
    bg="dark.800"
    borderRadius="md"
    align="center"
    justify="center"
    {...rest}
  >
    <HoneySlider
      label={label}
      max={max}
      value={values[valueKey]?.amount || BigNumber.from("0")}
      onChange={(value: BigNumber) => onChange(valueKey, value)}
    />

    <IconButton
      borderRadius="full"
      colorScheme="dark"
      size="sm"
      aria-label=""
      color={values[valueKey]?.isLocked ? "secondary.500" : "bright.50"}
      icon={
        values[valueKey]?.isLocked ? (
          <Icon as={FaLock} />
        ) : (
          <Icon as={FaLockOpen} />
        )
      }
      onClick={() => onLockToggle(valueKey, !values[valueKey]?.isLocked)}
    />
  </HStack>
);

export default HoneyPurchaseContainerSlider;
